export default function Projects() {
    return <h2>Projects</h2>;
}